export default __webpack_public_path__ + "73b62b8f5af27114db2af4e1a55cffb5.svg";